import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    "Missing Supabase credentials. Ensure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in .env",
  );
}

export const supabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: "pkce",
  },
});

// Log auth state changes - dev only for debugging
supabaseClient.auth.onAuthStateChange((event, session) => {
  if (import.meta.env.DEV && event !== "INITIAL_SESSION") {
    console.log("[OAuth] Auth state:", event, {
      user: session?.user?.email,
      provider: session?.user?.app_metadata?.provider,
    });
  }
});
